import { useCallback, useState } from 'react'

type Callback = () => void
type Hook = (initial: boolean) => [boolean, Callback, Callback, Callback]

export const useBoolean: Hook = (initial) => {
  const [value, set] = useState(initial)
  const toggle = useCallback(() => set((x) => !x), [])
  const setFalse = useCallback(() => set(false), [])
  const setTrue = useCallback(() => set(true), [])
  return [value, toggle, setFalse, setTrue]
}
